import React, { Suspense } from 'react'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import Blog from './pages/Blog'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import BlogCardDetail from './pages/BlogCardDetail'
import Projects from './pages/Projects'
import ProjectDetails from './pages/ProjectDetails'
import About from './pages/About'
import WhatsappBtn from './components/WhatsappBtn'
import ScrollToTop from './components/ScrollToTop'

const Main = () => {
  return (
    <Router>
      <ScrollToTop />
      <Suspense fallback={<div className='p-10 text-center'>Loading...</div>}>
        <Navbar />
        <div className="whatsappBtn fixed right-4 bottom-8 z-30 shadow-xl transform hover:-translate-y-3 transition-transform duration-300">
          <WhatsappBtn />
        </div>
        <Routes>
          <Route path='/' element={<Home />} />
          {/* <Route path='/' element={<Home />} /> */}
          <Route path='/about' element={<About />} />
          <Route path='/projects' element={<Projects />} />
          <Route path='/projects/projectdetails/:id' element={<ProjectDetails />} />
          <Route path='/blog' element={<Blog />} />
          <Route path='/blog/cardDetail/:id' element={<BlogCardDetail />} />
        </Routes>
        <Footer />
      </Suspense>
    </Router>
  )
}

export default Main
